<template functional>
    <div>...</div>
</template>

<script>
    export default {
        name: 'blank-action',
    };
</script>
